<template>
  <div>
    <vx-card v-if="this.mantenimiento" card-border class="mb-4" title="MANTENIMIENTO ACTIVADO" title-color="dark" collapseAction>
      <div class="vx-row w-full">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No se pueden crear operaciones nuevas mientras no termine el mantenimiento.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>

    <div v-if="!this.mantenimiento">

    <vx-card card-border class="mb-4" title="Datos de la operación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Fecha operación *</span>
          </div>
          <div>
            <flat-pickr data-vv-as="FECHA" name="fecha" v-validate="'required'" :config="configdateTimePicker" v-model="operacion.fecha" />
            <span class="text-danger text-sm"  v-show="errors.has('fecha')">{{ errors.first('fecha') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Tipo de cliente *</span>
          </div>
          <div>
            <select-tipo-cliente v-model="operacion.tipoCliente" />
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Operador *</span>
          </div>
          <div>
            <select-operador v-model="operacion.operador" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Estado</span>
          </div>
          <div>
            <!-- Inicialmente a operación sempre se creará co estado 'INCOMPLETA' -->
            <select-val-estado v-model="operacion.valEstado" categoria="OPERACION" :estadoSelected="'INCOMPLETA'" disabled />
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos del cliente" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">DNI/CIF *</span>
          </div>
          <div>
            <vx-input-group>
              <vs-input class="w-full" data-vv-as="DNICliente" v-validate="'required|alpha_num|checkDNI'" name="dniCliente" v-model="cliente.dni" 
                v-on:keyup="borrarCamposCliente" @input="v => { cliente.dni = v.toUpperCase()}"/>
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona('CLIENTE')" />
                </div>
              </template>
            </vx-input-group>
            <span class="text-danger text-sm"  v-show="errors.has('dniCliente')">{{ errors.first('dniCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span class="campoObligatorio">Fecha nacimiento *</span>
          </div>
          <div>
            <flat-pickr name="fechaNacimiento" data-vv-as="FECHA NACIMIENTO" v-validate="'required'" :config="configdateTimePicker" 
              v-model="cliente.fechaNacimiento" :disabled="fechaNacimientoClienteDisabled" />
            <span class="text-danger text-sm"  v-show="errors.has('fechaNacimiento')">{{ errors.first('fechaNacimiento') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Nombre o razón social *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreCliente" v-model="cliente.nombre" 
              :disabled="clienteDisabled" @input="v => { cliente.nombre = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('nombreCliente')">{{ errors.first('nombreCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" name="apellidosCliente" v-model="cliente.apellidos" :disabled="clienteDisabled" 
              @input="v => { cliente.apellidos = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Móvil de contacto *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
              name="telefonoCliente" v-model="operacionPersonaCliente.telefono" :disabled="movilClienteDisabled"/>
            <span class="text-danger text-sm"  v-show="errors.has('telefonoCliente')">{{ errors.first('telefonoCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">E-mail *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="E-MAIL" v-validate="'email'" name="emailCliente" v-model="operacionPersonaCliente.email"
               :disabled="emailClienteDisabled"/>
            <span class="text-danger text-sm"  v-show="errors.has('emailCliente')">{{ errors.first('emailCliente') }}</span>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Dirección de instalación" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Dirección *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="DIRECCIÓN" v-validate="'required'" name="direccionInstalacion" :disabled="direccionInstalacionDisabled" 
              v-model="direccionInstalacion.direccion" @input="v => { direccionInstalacion.direccion = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('direccionInstalacion')">{{ errors.first('direccionInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span class="campoObligatorio">Núm. *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NÚMERO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/ }" name="numeroInstalacion" 
              v-model="direccionInstalacion.numero" :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.numero = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('numeroInstalacion')">{{ errors.first('numeroInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Portal</span>
          </div>
          <div>
            <vs-input class="w-full" name="portal" v-model="direccionInstalacion.portal" :disabled="direccionInstalacionDisabled"
             @input="v => { direccionInstalacion.portal = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Escalera</span>
          </div>
          <div>
            <vs-input class="w-full" name="escalera" v-model="direccionInstalacion.escalera" :disabled="direccionInstalacionDisabled"
             @input="v => { direccionInstalacion.escalera = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span class="campoObligatorio">Planta *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="PLANTA" v-validate="'required'" name="plantaInstalacion" v-model="direccionInstalacion.planta" 
              :disabled="direccionInstalacionDisabled" @input="v => { direccionInstalacion.planta = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('plantaInstalacion')">{{ errors.first('plantaInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Puerta</span>
          </div>
          <div>
            <vs-input class="w-full" name="puerta" v-model="direccionInstalacion.puerta" :disabled="direccionInstalacionDisabled"
             @input="v => { direccionInstalacion.puerta = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Localidad</span>
          </div>
          <div>
            <vs-input class="w-full" name="localidad" v-model="direccionInstalacion.localidad" :disabled="direccionInstalacionDisabled"
             @input="v => { direccionInstalacion.localidad = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Municipio *</span>
          </div>
          <div>
            <select-val-municipio class="w-full" name="municipio" v-model="direccionInstalacion.municipio" :municipioSelected="direccionInstalacion.municipio"
              :disabled="municipioDireccionInstalacionDisabled" ref="cambiarEstado"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-2/12 w-full">
          <div>
            <span class="campoObligatorio">Cód. Postal *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="CÓD. POSTAL" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 5, max: 5 }" 
              name="cpInstalacion" :disabled="direccionInstalacionDisabled" v-model="direccionInstalacion.cp"/>
            <span class="text-danger text-sm"  v-show="errors.has('cpInstalacion')">{{ errors.first('cpInstalacion') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-4/12 w-full">
          <div>
            <span class="campoObligatorio">Provincia *</span>
          </div>
          <div>
            <select-val-provincia class="w-full" name="provincia" v-model="direccionInstalacion.provincia" :provinciaSelected="direccionInstalacion.provincia"
              :disabled="provinciaDireccionInstalacionDisabled"/>
          </div>
        </div>
        <div class="vx-col sm:w-6/12 w-full">
          <div>
            <span>Pais</span>
          </div>
          <div>
            <vs-input class="w-full" name="pais" v-model="direccionInstalacion.pais" :disabled="direccionInstalacionDisabled"
             @input="v => { direccionInstalacion.pais = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Dirección del cliente (dirección de facturación)" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          ¿La dirección del cliente es la misma que la de instalación?
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.direccionClienteIgualInstalacion" vs-name="direccionClienteIgualInstalacion" vs-value="S">Sí</vs-radio>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.direccionClienteIgualInstalacion" vs-name="direccionClienteIgualInstalacion" vs-value="N">No</vs-radio>
        </div>
      </div>
      <div v-if="operacion.direccionClienteIgualInstalacion === 'N'">
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">Dirección *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="DIRECCIÓN" v-validate="'required'" name="direccionCliente" v-model="direccionCliente.direccion"
                :disabled="direccionClienteDisabled" @input="v => { direccionCliente.direccion = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('direccionCliente')">{{ errors.first('direccionCliente') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span class="campoObligatorio">Núm. *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="NÚMERO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/ }" name="numeroCliente" 
                v-model="direccionCliente.numero" :disabled="direccionClienteDisabled" @input="v => { direccionCliente.numero = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('numeroCliente')">{{ errors.first('numeroCliente') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span>Portal</span>
            </div>
            <div>
              <vs-input class="w-full" name="portal" v-model="direccionCliente.portal" :disabled="direccionClienteDisabled"
                @input="v => { direccionCliente.portal = v.toUpperCase()}"/>
            </div>
          </div>
          <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span>Escalera</span>
            </div>
            <div>
              <vs-input class="w-full" name="escalera" v-model="direccionCliente.escalera" :disabled="direccionClienteDisabled" 
                @input="v => { direccionCliente.escalera = v.toUpperCase()}"/>
            </div>
          </div>
          <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span class="campoObligatorio">Planta *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="PLANTA" v-validate="'required'" name="plantaCliente" v-model="direccionCliente.planta" 
                :disabled="direccionClienteDisabled" @input="v => { direccionCliente.planta = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('plantaCliente')">{{ errors.first('plantaCliente') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span>Puerta</span>
            </div>
            <div>
              <vs-input class="w-full" name="puerta" v-model="direccionCliente.puerta" :disabled="direccionClienteDisabled" 
                @input="v => { direccionCliente.puerta = v.toUpperCase()}"/>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span>Localidad</span>
            </div>
            <div>
              <vs-input class="w-full" name="localidad" v-model="direccionCliente.localidad" :disabled="direccionClienteDisabled" 
                @input="v => { direccionCliente.localidad = v.toUpperCase()}"/>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div>
              <span class="campoObligatorio">Municipio *</span>
            </div>
            <div>
              <select-val-municipio class="w-full" name="municipio" v-model="direccionCliente.municipio" :municipioSelected="direccionCliente.municipio"
                :disabled="municipioDireccionClienteDisabled" ref="cambiarEstado"/>
            </div>
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-2/12 w-full">
            <div>
              <span class="campoObligatorio">Cód. Postal *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="CÓD. POSTAL" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 5, max: 5 }" 
                  name="cpCliente" v-model="direccionCliente.cp" :disabled="direccionClienteDisabled"/>
                <span class="text-danger text-sm"  v-show="errors.has('cpCliente')">{{ errors.first('cpCliente') }}</span>
            </div>
          </div>
          <div class="vx-col sm:w-4/12 w-full">
            <div>
              <span class="campoObligatorio">Provincia *</span>
            </div>
            <div>
              <select-val-provincia class="w-full" name="provincia" v-model="direccionCliente.provincia" :provinciaSelected="direccionCliente.provincia"
                :disabled="provinciaDireccionClienteDisabled"/>
            </div>
          </div>
          <div class="vx-col sm:w-6/12 w-full">
            <div>
              <span>Pais</span>
            </div>
            <div>
              <vs-input class="w-full" name="pais" v-model="direccionCliente.pais" :disabled="direccionClienteDisabled" 
                @input="v => { direccionCliente.pais = v.toUpperCase()}"/>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos del decisor (representante)" title-color="dark" collapseAction 
       v-if="operacion.tipoCliente === 'EMPRESA'">
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">DNI/CIF *</span>
          </div>
          <div>
            <vx-input-group>
              <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniDecisor" v-model="decisor.dni" 
                v-on:keyup="borrarCamposDecisor" @input="v => { decisor.dni = v.toUpperCase()}"/>
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona('DECISOR')" />
                </div>
              </template>
            </vx-input-group>
            <span class="text-danger text-sm"  v-show="errors.has('dniDecisor')">{{ errors.first('dniDecisor') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Cargo</span>
          </div>
          <div>
            <vs-input class="w-full" name="cargo" v-model="operacionPersonaDecisor.cargo" @input="v => { operacionPersonaDecisor.cargo = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Nombre *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreDecisor" v-model="decisor.nombre" 
              :disabled="decisorDisabled" @input="v => { decisor.nombre = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('nombreDecisor')">{{ errors.first('nombreDecisor') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Apellidos *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="APELLIDOS" v-validate="'required'" name="apellidosDecisor" v-model="decisor.apellidos" 
              :disabled="decisorDisabled" @input="v => { decisor.apellidos = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('apellidosDecisor')">{{ errors.first('apellidosDecisor') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Móvil de contacto *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
              name="telefonoDecisor" v-model="operacionPersonaDecisor.telefono" :disabled="movilDecisorDisabled"/>
            <span class="text-danger text-sm"  v-show="errors.has('telefonoDecisor')">{{ errors.first('telefonoDecisor') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">E-mail *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="E-MAIL" v-validate="'email'" name="emailDecisor" v-model="operacionPersonaDecisor.email" 
              :disabled="emailDecisorDisabled"/>
            <span class="text-danger text-sm"  v-show="errors.has('emailDecisor')">{{ errors.first('emailDecisor') }}</span>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Datos bancarios" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full">
          ¿El titular de la cuenta bancaria es el cliente?
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.titularIgualCliente" vs-name="titularIgualCliente" vs-value="S">Sí</vs-radio>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <vs-radio v-model="operacion.titularIgualCliente" vs-name="titularIgualCliente" vs-value="N">NO</vs-radio>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Cuenta bancaria *</span>
          </div>
          <div>
            <!-- https://es.iban.com/estructura -->
            <vs-input class="w-full" data-vv-as="IBAN" v-validate="'checkIBAN'" name="iban" placeholder="ES0000000000000000000000" 
              v-model="operacion.iban"/>
            <span class="text-danger text-sm"  v-show="errors.has('iban')">{{ errors.first('iban') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.titularIgualCliente === 'N'">
          <div>
            <span class="campoObligatorio">DNI/CIF *</span>
          </div>
          <div>
            <vx-input-group>
              <vs-input class="w-full" data-vv-as="DNI" v-validate="'required|alpha_num|checkDNI'" name="dniTitular" v-model="titularCuenta.dni"
              v-on:keyup="borrarCamposTitular" @input="v => { titularCuenta.dni = v.toUpperCase()}"/>
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona('TITULAR')" />
                </div>
              </template>
            </vx-input-group>
            <span class="text-danger text-sm"  v-show="errors.has('dniTitular')">{{ errors.first('dniTitular') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2" v-if="operacion.titularIgualCliente === 'N'">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Nombre o razón social *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreTitular" v-model="titularCuenta.nombre"
              :disabled="titularDisabled" @input="v => { titularCuenta.nombre = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('nombreTitular')">{{ errors.first('nombreTitular') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" name="apellidosTitular" v-model="titularCuenta.apellidos" :disabled="titularDisabled" @input="v => { titularCuenta.apellidos = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
    </vx-card>

    <popup-buscar-persona :popupProps="popupProps" @aceptar="popupBuscarPersonaAction" ref="consultarDni" />

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>

    </div>
    
  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import personasStore from '@/store/gestion/personas/index.js'
import empresasStore from '@/store/configuracion/empresas/index.js'

import selectValEstado from '@/views/common-components/selectValEstado'
import selectOperador from '@/views/common-components/selectOperador'
import selectTipoCliente from '@/views/common-components/selectTipoCliente'
import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'
import popupBuscarPersona from '@/views/common-components/popupBuscarPersona'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'OperacionesNewOperacion',
  components: {
    selectValEstado,
    selectOperador,
    selectTipoCliente,
    selectValMunicipio,
    selectValProvincia,
    popupBuscarPersona,
    flatPickr,
    SpanishLocale
  },
  data () {
    return {
      mantenimiento: null,
      operacion: {
        operacionPersonas: [],
        titularIgualCliente: 'S',
        direccionClienteIgualInstalacion: 'S',
        valEstado: '/api/val_estados/1',  // A operación sempre se da de alta co estado 'INCOMPLETA'
        porcentajeCompletado: 25  // Cando a operación se garde, ten o 25% dos datos necesarios completados
      },
      cliente: {
        direcciones: [],
        fechaNacimiento: null,
        apellidos: null
      },
      // Propiedades para deshabilitar campos que se poden obter si a persoa xa existe na BD
      clienteDisabled: true,
      fechaNacimientoClienteDisabled: true,
      movilClienteDisabled: true,
      emailClienteDisabled: true,
      direccionClienteDisabled: true,
      municipioDireccionClienteDisabled: true,
      provinciaDireccionClienteDisabled: true,
      direccionInstalacionDisabled: true,
      municipioDireccionInstalacionDisabled: true,
      provinciaDireccionInstalacionDisabled: true,
      decisorDisabled: true,
      movilDecisorDisabled: true,
      emailDecisorDisabled: true,
      titularDisabled: true,
      // Ids dos obxectos ao darlle a gardar
      clienteId: null,
      clienteDireccionId: null,
      decisorId: null,
      titularId: null,
      operacionId: null, 
      operacionDireccionInstalacionId: null,

      operacionPersonaCliente: {},
      operacionPersonaDecisor: {},
      // operacionPersonaTitular: {},
      decisor: {
        nombre: null,
        apellidos: null
      },
      titularCuenta: {
        nombre: null,
        apellidos: null
      },
      direccionCliente: {
        direccion: null,
        numero: null,
        portal: null,
        escalera: null,
        planta: null,
        puerta: null,
        localidad: null,
        municipio: null,
        cp: null,
        provincia: null,
        pais: null
      },
      direccionInstalacion: {
        direccion: null,
        numero: null,
        portal: null,
        escalera: null,
        planta: null,
        puerta: null,
        localidad: null,
        municipio: null,
        cp: null,
        provincia: null,
        pais: null
      },

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      },
      // popupBuscarPersona
      popupProps: {
        activo: false,
        dni: null,
        relacion: null,  // Relación da persoa coa operación: CLIENTE, DECISOR ou TITULAR
        origenLlamadaPopUp: 'NUEVA'  // O Popup ábrese desde a pantalla de nova operación
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() 
        || this.operacion.fecha === null || this.operacion.fecha === undefined
        || this.operacion.tipoCliente === null || this.operacion.tipoCliente === undefined 
        || this.operacion.operador === null || this.operacion.operador === undefined
        // || this.operacion.valEstado === null || this.operacion.valEstado === undefined
        || this.cliente.dni === null || this.cliente.dni === undefined 
        || this.cliente.nombre === null || this.cliente.nombre === undefined 
        || (this.operacion.tipoCliente !== 'EMPRESA' 
          && (this.cliente.fechaNacimiento === null || this.cliente.fechaNacimiento === undefined))
        || this.operacionPersonaCliente.telefono === null || this.operacionPersonaCliente.telefono === undefined 
        || this.operacionPersonaCliente.email === null || this.operacionPersonaCliente.email === undefined 
        || this.direccionInstalacion.direccion === null || this.direccionInstalacion.direccion === undefined
        || this.direccionInstalacion.numero === null || this.direccionInstalacion.numero === undefined
        || this.direccionInstalacion.planta === null || this.direccionInstalacion.planta === undefined
        || this.direccionInstalacion.municipio === null || this.direccionInstalacion.municipio === undefined 
        || this.direccionInstalacion.cp === null || this.direccionInstalacion.cp === undefined
        || this.direccionInstalacion.provincia === null || this.direccionInstalacion.provincia === undefined 
        || (this.operacion.tipoCliente === 'EMPRESA' 
          && (this.decisor.dni === null || this.decisor.dni === undefined 
            || this.decisor.nombre === null || this.decisor.nombre === undefined 
            || this.decisor.apellidos === null || this.decisor.apellidos === undefined 
            || this.operacionPersonaDecisor.telefono === null || this.operacionPersonaDecisor.telefono === undefined 
            || this.operacionPersonaDecisor.email === null || this.operacionPersonaDecisor.email === undefined))
        || this.operacion.iban === null || this.operacion.iban === undefined 
        || (this.operacion.titularIgualCliente === 'N' 
          && (this.titularCuenta.dni === null || this.titularCuenta.dni === undefined
            || this.titularCuenta.nombre === null || this.titularCuenta.nombre === undefined))
        || (this.operacion.direccionClienteIgualInstalacion === 'N'
          && (this.direccionCliente.direccion === null || this.direccionCliente.direccion === undefined
            || this.direccionCliente.municipio === null || this.direccionCliente.municipio === undefined 
            || this.direccionCliente.numero === null || this.direccionCliente.numero === undefined 
            || this.direccionCliente.planta === null || this.direccionCliente.planta === undefined 
            || this.direccionCliente.cp === null || this.direccionCliente.cp === undefined 
            || this.direccionCliente.provincia === null || this.direccionCliente.provincia === undefined)) 
      ) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    async guardar () {
      if (!this.validateForm) return

      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      let errorAlGuardar = false

      if (this.operacion.direccionClienteIgualInstalacion === 'S') this.direccionCliente = JSON.parse(JSON.stringify(this.direccionInstalacion))

      // CLIENTE
      if (this.clienteId === null) {  // Gardamos un novo cliente e a súa dirección, posto que non existía en BD (clienteId === null)
        this.cliente.direcciones.push(this.direccionCliente) // Engadimos a dirección do cliente que introduce o usuario
        errorAlGuardar = await this.guardarPersona('CLIENTE')
      } else if (this.clienteDireccionId === null) { // Se o usuario non seleccionou ningunha das direccións do cliente e hai que crear unha nova
        errorAlGuardar = await this.guardarDireccion('CLIENTE')
        // Se o usuario seleccionou unha dirección das existentes xa se asigna en OperacionPersona ao gardar esa entidade
      }

      // Se o cliente xa existía en BD asegurámonos de gardar a data de nacemento
      if (this.clienteId !== null && this.operacion.tipoCliente !== 'EMPRESA') {
        const c = {}
        c.id = this.clienteId
        c.fechaNacimiento = this.cliente.fechaNacimiento
        await this.$store.dispatch('personasStore/updatePersona', c)
      }

      // DECISOR
      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos
      // Gardamos un novo decisor posto que non existía en BD (decisorId === null) e o cliente é de tipo empresa
      if (this.operacion.tipoCliente === 'EMPRESA' && this.decisorId === null) {  
        errorAlGuardar = await this.guardarPersona('DECISOR')
      }

      // TITULAR
      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos
      // Gardamos un novo titular posto que non existía en BD (titularId === null) e non é o mesmo que o cliente nin o decisor (DNI do decisor distinto do DNI do cliente)
      if (this.operacion.titularIgualCliente === 'N' && this.titularId === null && this.decisor.dni !== this.titularCuenta.dni) {  
        errorAlGuardar = await this.guardarPersona('TITULAR')
      }

      // OPERACIÓN
      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos
      errorAlGuardar = await this.guardarOperacion() 

      // RELACIÓN OPERACIÓN-PERSONAS
      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos
      errorAlGuardar = await this.guardarOperacionPersona('CLIENTE')
      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos
      if (this.operacion.tipoCliente === 'EMPRESA') {
        errorAlGuardar = await this.guardarOperacionPersona('DECISOR')
      }
      if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos
      errorAlGuardar = await this.guardarOperacionPersona('TITULAR')

      if (!errorAlGuardar) {
        this.showUpdateSuccess(this.operacionId)
        await this.$store.dispatch('operacionesStore/altaOperacion', true)
        await this.$store.dispatch('operacionesStore/getOperacion', this.operacionId)
        this.$router.push({name: 'operacionesEditar', params: { operacionId: this.operacionId } })
      }
    },
    async guardarOperacion () {
      let error = false
      // Comprobamos se a dirección de instalación é a mesma que a do cliente, senón creámola
      if (this.operacion.direccionClienteIgualInstalacion === 'S') {
        this.operacion.direccion = `/api/direccions/${this.clienteDireccionId}`
      } else {
        error = await this.guardarDireccion('INSTALACION')
        this.operacion.direccion = `/api/direccions/${this.operacionDireccionInstalacionId}`
      }
      await this.$store.dispatch('operacionesStore/addOperacion', this.operacion)
        .then((response)   => { 
          this.operacionId = response.data.id
        })
        .catch((error) => {
          this.showUpdateError(error)
          error = false
        })
      return error
    },
    async guardarPersona (tipoPersona) {
      let persona = {}
      if (tipoPersona === 'CLIENTE') {
        persona = JSON.parse(JSON.stringify(this.cliente))
      } else if (tipoPersona === 'DECISOR') {
        persona = JSON.parse(JSON.stringify(this.decisor))
      } else if (tipoPersona === 'TITULAR') {
        persona = JSON.parse(JSON.stringify(this.titularCuenta))
      }
      await this.$store.dispatch('personasStore/addPersona', persona)
        .then((response)   => { 
          if (tipoPersona === 'CLIENTE') {
            this.clienteId = response.data.id
            if (this.decisor.dni === this.cliente.dni) this.decisorId = this.clienteId
            this.clienteDireccionId = response.data.direcciones[0].id
          } else if (tipoPersona === 'DECISOR') {
            this.decisorId = response.data.id
          } else if (tipoPersona === 'TITULAR') {
            this.titularId = response.data.id
          }
        })
        .catch((error) => {
          this.showUpdateError(error)
          return false
        })
    },
    async guardarDireccion (tipo) {
      let d = {}
      if (tipo === 'CLIENTE') {
        this.direccionCliente.persona = `/api/personas/${this.clienteId}`  // Relacionamos a dirección que se vai insertar co id do cliente
        d = JSON.parse(JSON.stringify(this.direccionCliente))
      } else {
        d = JSON.parse(JSON.stringify(this.direccionInstalacion))
      }

      await this.$store.dispatch('personasStore/addDireccion', d)
        .then((response)   => { 
          if (tipo === 'CLIENTE') {
            this.clienteDireccionId = response.data.id
          } else {
            this.operacionDireccionInstalacionId = response.data.id
          }
        })
        .catch((error) => {
          this.showUpdateError(error)
          return false
        })
    },
    async guardarOperacionPersona (tipoPersona) {
      let operacionPersona = {}
      if (tipoPersona === 'CLIENTE') {
        operacionPersona = JSON.parse(JSON.stringify(this.operacionPersonaCliente))
        operacionPersona.relacion = tipoPersona
        operacionPersona.operacion = `/api/operacions/${this.operacionId}`
        operacionPersona.persona = `/api/personas/${this.clienteId}`
        operacionPersona.cargo = null
        operacionPersona.telefono = this.operacionPersonaCliente.telefono
        operacionPersona.email = this.operacionPersonaCliente.email
        operacionPersona.direccion = `/api/direccions/${this.clienteDireccionId}`
      } else if (tipoPersona === 'DECISOR') {
        operacionPersona = JSON.parse(JSON.stringify(this.operacionPersonaDecisor))
        operacionPersona.relacion = tipoPersona
        operacionPersona.operacion = `/api/operacions/${this.operacionId}`
        operacionPersona.persona = `/api/personas/${this.decisorId}`
        operacionPersona.cargo = this.operacionPersonaDecisor.cargo
        operacionPersona.telefono = this.operacionPersonaDecisor.telefono
        operacionPersona.email = this.operacionPersonaDecisor.email
        operacionPersona.direccion = null
      } else if (tipoPersona === 'TITULAR') {
        operacionPersona.relacion = tipoPersona
        operacionPersona.operacion = `/api/operacions/${this.operacionId}`
        if (this.operacion.titularIgualCliente === 'N') {
          if (this.decisor.dni === this.titularCuenta.dni) {  // No caso de que a resposta fose NON, pero se introducir a mesmo DNI para o decisor que para o titular
            operacionPersona.persona = `/api/personas/${this.decisorId}`
          } else {
            operacionPersona.persona = `/api/personas/${this.titularId}`
          }
        } else {  // O cliente e o titular da conta son a mesma persoa
          operacionPersona.persona = `/api/personas/${this.clienteId}`
        }
        operacionPersona.cargo = null
        operacionPersona.telefono = null
        operacionPersona.email = null
        operacionPersona.direccion = null
      }

      await this.$store.dispatch('operacionesStore/addOperacionPersona', operacionPersona)
        .then(() => { 
        })
        .catch((error) => {
          this.showUpdateError(error)
          return false
        })
    },
    showErroDeDatos (erro) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error de validación de datos',
        text: erro
      })
    },
    showUpdateSuccess (id) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'SE HA GUARDADO LA OPERCIÓN CORRECTAMENTE',
        text: `ID de la operación: ${id}`
      })
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR GUARDANDO LA OPERACIÓN',
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    borrarCamposCliente () {
      // Habilitamos os campos (con eles deshabilitados cambiar os valores compórtase erróneamente)
      this.clienteDisabled = false
      this.fechaNacimientoClienteDisabled = false
      this.movilClienteDisabled = false
      this.emailClienteDisabled = false
      this.direccionClienteDisabled = false
      this.municipioDireccionClienteDisabled = false
      this.provinciaDireccionClienteDisabled = false
      this.direccionInstalacionDisabled = false
      this.municipioDireccionInstalacionDisabled = false
      this.provinciaDireccionInstalacionDisabled = false
      // Baleiramos os campos por se chama ao popup máis dunha vez e selecciona outros valores
      this.clienteId = null
      this.clienteDireccionId = null
      this.cliente.fechaNacimiento = null
      this.cliente.nombre = null
      this.cliente.apellidos = null
      this.operacionPersonaCliente.telefono = null
      this.operacionPersonaCliente.email = null
      this.direccionCliente.direccion = null
      this.direccionCliente.numero = null
      this.direccionCliente.portal = null
      this.direccionCliente.escalera = null
      this.direccionCliente.planta = null
      this.direccionCliente.puerta = null
      this.direccionCliente.localidad = null
      this.direccionCliente.municipio = null
      this.direccionCliente.cp = null
      this.direccionCliente.provincia = null
      this.direccionCliente.pais = null
      this.operacionDireccionInstalacionId = null
      this.direccionInstalacion.direccion = null
      this.direccionInstalacion.numero = null
      this.direccionInstalacion.portal = null
      this.direccionInstalacion.escalera = null
      this.direccionInstalacion.planta = null
      this.direccionInstalacion.puerta = null
      this.direccionInstalacion.localidad = null
      this.direccionInstalacion.municipio = null
      this.direccionInstalacion.cp = null
      this.direccionInstalacion.provincia = null
      this.direccionInstalacion.pais = null

      // Deshabilitamos os campos
      this.clienteDisabled = true
      this.fechaNacimientoClienteDisabled = true
      this.movilClienteDisabled = true
      this.emailClienteDisabled = true
      this.direccionClienteDisabled = true
      this.municipioDireccionClienteDisabled = true
      this.provinciaDireccionClienteDisabled = true
      this.direccionInstalacionDisabled = true
      this.municipioDireccionInstalacionDisabled = true
      this.provinciaDireccionInstalacionDisabled = true
    },
    borrarCamposDecisor () {
      // Habilitamos os campos (con eles deshabilitanos cambiar os valores compórtase erróneamente)
      this.decisorDisabled = false
      this.movilDecisorDisabled = false
      this.emailDecisorDisabled = false
      // Borramos os campos
      this.decisorId = null
      this.decisor.nombre = null
      this.decisor.apellidos = null
      this.operacionPersonaDecisor.telefono = null
      this.operacionPersonaDecisor.email = null
      // Deshabilitamos os campos
      this.decisorDisabled = true
      this.movilDecisorDisabled = true
      this.emailDecisorDisabled = true
    },
    borrarCamposTitular () {
      // Habilitamos os campos
      this.titularDisabled = false
      // Borramos os campos
      this.titularId = null
      this.titularCuenta.nombre = null
      this.titularCuenta.apellidos = null
      // Deshabilitamos os campos
      this.titularDisabled = true
    },
    abrirPopupBuscarPersona (relacion) {
      this.popupProps.relacion = relacion
      if (relacion === 'CLIENTE' && !this.errors.has('dniCliente') && this.cliente.dni !== null && this.cliente.dni !== undefined) {
        this.popupProps.dni = this.cliente.dni
        this.clienteId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
        this.clienteDireccionId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
        // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
        this.borrarCamposCliente()
        // Chamamos ao método do popup
        this.$refs.consultarDni.consultarDni()
      } else if (relacion === 'DECISOR' && !this.errors.has('dniDecisor') && this.decisor.dni !== null && this.decisor.dni !== undefined) {
        this.popupProps.dni = this.decisor.dni
        this.decisorId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
        // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
        this.borrarCamposDecisor()
        // Chamamos ao método do popup
        this.$refs.consultarDni.consultarDni()
      } else if (relacion === 'TITULAR' && !this.errors.has('dniTitular') && this.titularCuenta.dni !== null && this.titularCuenta.dni !== undefined) {
        // Veriricamos que non se intruduce o mesmo DNI que o do cliente ou decisor
        if (this.titularCuenta.dni === this.cliente.dni) {
          this.showErroDeDatos('Se ha marcado que el titular de la cuenta y el cliente son distintos, sin embargo tienen el mismo DNI') 
        } else {
          this.popupProps.dni = this.titularCuenta.dni
          this.titularId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
          // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
          this.borrarCamposTitular()
          // Chamamos ao método do popup
          this.$refs.consultarDni.consultarDni()
        }
      }
    },
    popupBuscarPersonaAction (persona) {
      this.popupProps.activo = false  // Pechamos o popup
      // Xestionamos se o popup foi chamado desde o campo de DNI do CLIENTE
      if (persona.tipoPersona === 'CLIENTE') {
        if (persona.existe) { //Se a persoa existe imos asignando os datos aos campos do formuario, senón habilitamos os campos para introducilos a man
          this.clienteId = persona.personaId // Asignamos o id da persoa atopada para gardar na operación
          this.clienteDisabled = false // Habilitamos os campos para asignarlle os valores
          this.fechaNacimientoClienteDisabled = false

          this.cliente.fechaNacimiento = persona.fechaNacimiento
          this.cliente.nombre = persona.nombre
          this.cliente.apellidos = persona.apellidos

          this.clienteDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
          // Se o cliente non tiña data de nacemento mantemos o campo habilitado para que o usuario a poida introducir
          if (this.cliente.fechaNacimiento !== null && this.cliente.fechaNacimiento !== undefined) this.fechaNacimientoClienteDisabled = true

          if (persona.direccion !== 'NUEVA') {  //Se se seleccionou unha dirección cubrimos os campos, senón habilitámolos para engadilos a man
            
            if (persona.instalacion === 'S') {
              this.direccionInstalacionDisabled = false // Habilitamos os campos para asignarlle os valores
              this.municipioDireccionInstalacionDisabled = false // Habilitamos os campos para asignarlle os valores
              this.provinciaDireccionInstalacionDisabled = false // Habilitamos os campos para asignarlle os valores

              this.operacionDireccionInstalacionId = persona.direccionId // Asignamos o id da dirección seleccionada da persoa atopada
              this.direccionInstalacion.direccion = persona.direccion
              this.direccionInstalacion.numero = persona.numero
              this.direccionInstalacion.portal = persona.portal
              this.direccionInstalacion.escalera = persona.escalera
              this.direccionInstalacion.planta = persona.planta
              this.direccionInstalacion.puerta = persona.puerta
              this.direccionInstalacion.localidad = persona.localidad
              this.direccionInstalacion.municipio = `/api/val_municipios/${persona.municipioId}`
              this.direccionInstalacion.cp = persona.cp
              this.direccionInstalacion.provincia = `/api/val_provincias/${persona.provinciaId}`
              this.direccionInstalacion.pais = persona.pais

              this.direccionInstalacionDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
              this.municipioDireccionInstalacionDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
              this.provinciaDireccionInstalacionDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
            } else {
              this.direccionInstalacionDisabled = false // Habilitamos os campos para introducir a dirección a man
              this.municipioDireccionInstalacionDisabled = false // Habilitamos os campos para introducir a dirección a man
              this.provinciaDireccionInstalacionDisabled = false // Habilitamos os campos para introducir a dirección a man
            }

            if (persona.facturacion === 'S') { // DIRECCIÓN DE FACTURACIÓN es la DIRECCIÓN DEL CLIENTE
              this.direccionClienteDisabled = false // Habilitamos os campos para asignarlle os valores
              this.municipioDireccionClienteDisabled = false // Habilitamos os campos para asignarlle os valores
              this.provinciaDireccionClienteDisabled = false // Habilitamos os campos para asignarlle os valores

              this.clienteDireccionId = persona.direccionId // Asignamos o id da dirección seleccionada da persoa atopada
              this.direccionCliente.direccion = persona.direccion
              this.direccionCliente.numero = persona.numero
              this.direccionCliente.portal = persona.portal
              this.direccionCliente.escalera = persona.escalera
              this.direccionCliente.planta = persona.planta
              this.direccionCliente.puerta = persona.puerta
              this.direccionCliente.localidad = persona.localidad
              this.direccionCliente.municipio = `/api/val_municipios/${persona.municipioId}`
              this.direccionCliente.cp = persona.cp
              this.direccionCliente.provincia = `/api/val_provincias/${persona.provinciaId}`
              this.direccionCliente.pais = persona.pais

              this.direccionClienteDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
              this.municipioDireccionClienteDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
              this.provinciaDireccionClienteDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
            } else {
              this.direccionClienteDisabled = false // Habilitamos os campos para introducir a dirección a man
              this.municipioDireccionClienteDisabled = false // Habilitamos os campos para introducir a dirección a man
              this.provinciaDireccionClienteDisabled = false // Habilitamos os campos para introducir a dirección a man
            }

          } else {
            this.direccionClienteDisabled = false // Habilitamos os campos para introducir a dirección a man
            this.municipioDireccionClienteDisabled = false // Habilitamos os campos para introducir a dirección a man
            this.provinciaDireccionClienteDisabled = false // Habilitamos os campos para introducir a dirección a man
            this.direccionInstalacionDisabled = false // Habilitamos os campos para introducir a dirección a man
            this.municipioDireccionInstalacionDisabled = false // Habilitamos os campos para introducir a dirección a man
            this.provinciaDireccionInstalacionDisabled = false // Habilitamos os campos para introducir a dirección a man
          }
          if (persona.movil !== 'NUEVO') {  //Se se seleccionou un móbil cubrimos o campo, senón habilitámolo para que o usuario o engada
            this.movilClienteDisabled = false
            this.operacionPersonaCliente.telefono = persona.movil
            this.movilClienteDisabled = true
          } else {
            this.movilClienteDisabled = false // Habilitamos os campos para introducir o móbil a man
          }
          if (persona.email !== 'NUEVO') {  //Se se seleccionou un e-mail cubrimos o campo, senón habilitámolo para que o usuario o engada
            this.emailClienteDisabled = false
            this.operacionPersonaCliente.email = persona.email
            this.emailClienteDisabled = true
          } else {
            this.emailClienteDisabled = false // Habilitamos os campos para introducir o e-mail a man
          }
        } else { // A persoa non existe na BD. Habilitamos todos os campos para introducir a man
          this.clienteDisabled = false
          this.fechaNacimientoClienteDisabled = false
          this.movilClienteDisabled = false
          this.emailClienteDisabled = false
          this.direccionInstalacionDisabled = false
          this.municipioDireccionInstalacionDisabled = false
          this.provinciaDireccionInstalacionDisabled = false
          this.direccionClienteDisabled = false
          this.municipioDireccionClienteDisabled = false
          this.provinciaDireccionClienteDisabled = false
        }
      // Xestionamos se o popup foi chamado desde o campo de DNI do DECISOR
      } else if (persona.tipoPersona === 'DECISOR') {
        if (persona.existe) {
          this.decisorId = persona.personaId // Asignamos o id da persoa atopada para gardar na operación
          this.decisorDisabled = false
          this.decisor.nombre = persona.nombre
          this.decisor.apellidos = persona.apellidos
          this.decisorDisabled = true
          if (persona.movil !== 'NUEVO') {  //Se se seleccionou un móbil cubrimos o campo, senón habilitámolo para que o usuario o engada
            this.movilDecisorDisabled = false
            this.operacionPersonaDecisor.telefono = persona.movil
            this.movilDecisorDisabled = true
          } else {
            this.movilDecisorDisabled = false
          }
          if (persona.email !== 'NUEVO') {  //Se se seleccionou un e-mail cubrimos o campo, senón habilitámolo para que o usuario o engada
            this.emailDecisorDisabled = false
            this.operacionPersonaDecisor.email = persona.email
            this.emailDecisorDisabled = true
          } else {
            this.emailDecisorDisabled = false
          }
        } else {
          this.decisorDisabled = false
          this.movilDecisorDisabled = false
          this.emailDecisorDisabled = false
        }
      // Xestionamos se o popup foi chamado desde o campo de DNI do TITULAR
      } else if (persona.tipoPersona === 'TITULAR') {
        if (persona.existe) {
          this.titularId = persona.personaId // Asignamos o id da persoa atopada para gardar na operación
          this.titularDisabled = false
          this.titularCuenta.nombre = persona.nombre
          this.titularCuenta.apellidos = persona.apellidos
          this.titularDisabled = true
        } else {
          this.titularDisabled = false
        }
      }
    }
  },
  async created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }
    
    const empresaId = 1

    await this.$store.dispatch('empresasStore/getMantenimiento', empresaId)
    this.mantenimiento = this.$store.state.empresasStore.mantenimiento 

    // mostramos a data actual en 'fecha' para evitarlle ao usuario introducila
    const hoy = new Date()
    this.operacion.fecha = hoy.toISOString()
    // almacenamos o usuario que está creando a operación
    const usuario = JSON.parse(sessionStorage.getItem('userInfo'))
    this.operacion.usuario = `/api/usuarios/${usuario.uid}`
  }
}
</script>